module.exports = __webpack_public_path__ + "img/moved_ms.c84ceca5.png";